module.exports = __webpack_public_path__ + "img/zlpg2.56639f5.png";